import { all, call, put, takeLatest } from 'redux-saga/effects'
import { ApiClient } from '../../../../utilities/api';
import { setGetArchiveDocuments,setUpdateArchiveDocuments,onErrorStopLoad } from '../../../slices/documents/archiveDocuments';
import ApiPath from '../../../../constants/apiPath';
import { toast } from 'react-toastify';


function* AllArchiveDocuments(action) {
  try {
    const resp = yield call(ApiClient.get, action.url = `${ApiPath.DocumentApiPath.ArchiveApiPath.GET_ARCHIVE_DOCUMENT}?page=${action.payload.page}&limit=${action.payload.limit}`, action.payload = action.payload);
    if (resp.status) {
      yield put(setGetArchiveDocuments(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      // toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setGetArchiveDocuments({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}

function* UpdateArchiveDocument(action) {
  try {
    const resp = yield call(ApiClient.patch, action.url = `${ApiPath.DocumentApiPath.ArchiveApiPath.UPDATE_ARCHIVE_DOCUMENT}${action.payload.id}`,action.payload = action.payload);
    if (resp.status) {
      yield put(setUpdateArchiveDocuments(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setUpdateArchiveDocuments({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}


function* userArchiveDocuments() {
  yield all([
    takeLatest('archivedocuments/getArchiveDocuments', AllArchiveDocuments),
    takeLatest('archivedocuments/updateArchiveDocuments', UpdateArchiveDocument),
  ])
}

export default userArchiveDocuments;